import { Input } from '@hqo/react-components-library/dist/input';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 100%;
`;
